/**
 * sg-scripts.js
 */
((document) => {
  // Add js class to body
  document.getElementsByTagName('body')[0].classList.add('js');

  const selectText = (text) => {
    const doc = document;
    let range = doc.body.createTextRange();
    if (doc.body.createTextRange) {
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      const selection = window.getSelection();
      range = doc.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  // View Source Toggle
  document.querySelectorAll('.sg-btn--source').forEach((el) => {
    el.addEventListener('click', () => {
      const sourceCode = el.parentNode.nextElementSibling;
      sourceCode.classList.toggle('is-active');
      return false;
    });
  });

  // Select Code Button
  document.querySelectorAll('.sg-btn--select').forEach((el) => {
    el.addEventListener('click', () => {
      selectText(this.nextSibling);
      this.classList.toggle('is-active');
      return false;
    });
  });

  // Add operamini class to body
  if (window.operamini) {
    document.getElementsByTagName('body')[0].classList.add('operamini');
  }
})(document);

window.addEventListener('load', () => {
  // eslint-disable-next-line no-console
  console.log('_JS_READY');
});
